module.exports = __webpack_public_path__ + "img/gt-logo.ef56d3a5.svg";